import { render } from "./v1_idx.vue?vue&type=template&id=4c23056a"
import script from "./v1_idx.vue?vue&type=script&lang=js"
export * from "./v1_idx.vue?vue&type=script&lang=js"

import "./v1_idx.vue?vue&type=style&index=0&id=4c23056a&lang=scss"

import exportComponent from "D:\\Workspace_git\\carrot\\pron_front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__